import { AbstractControl, FormGroup } from '@angular/forms';

export const markControlsAsTouched = (formGroup: FormGroup) => {
  for (const field of Object.keys(formGroup.controls)) {
    const control: AbstractControl = formGroup.get(field);
    control.markAsTouched({ onlySelf: true });
  }
};
